import { Type } from "class-transformer";
import { DocumentOutDTO } from "../document/document.out.dto";
import { ContractChangeLogOutDTO } from "./contract-change-log.out.dto";
import { ContractTemplateSummaryOutDTO } from "./contract-template-summary.out.dto";
import { ContractType } from "./contract-type.enum";
import { ContractGenerationMethod } from "./type/contract-generation-method.enum";

export class ContractSummaryOutDTO {
  id!: string;
  type!: ContractType;
  generationMethod!: ContractGenerationMethod;
  status!: string;
  statusAddendum?: Record<string, unknown>;

  @Type(() => DocumentOutDTO)
  documentHistory!: DocumentOutDTO[];

  @Type(() => DocumentOutDTO)
  lastDocument?: DocumentOutDTO;

  @Type(() => ContractChangeLogOutDTO)
  changeLogs?: ContractChangeLogOutDTO[];

  @Type(() => ContractTemplateSummaryOutDTO)
  template?: ContractTemplateSummaryOutDTO;

  customFieldsValue?: Record<string, unknown>;
}
